import { render, staticRenderFns } from "./recognized-call-text.vue?vue&type=template&id=5749451a&scoped=true&"
import script from "./recognized-call-text.vue?vue&type=script&lang=js&"
export * from "./recognized-call-text.vue?vue&type=script&lang=js&"
import style0 from "./recognized-call-text.vue?vue&type=style&index=0&id=5749451a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5749451a",
  null
  
)

export default component.exports